export default __webpack_public_path__ + "static/grafika_expand-cbd599b24632ac6324ad7c19a471fa31.png";